import { useKeycloak } from "@react-keycloak/web";
import { ProfileProvider } from "./components/common/ProfileProvider";
import App from "./App";
import { BeatLoader } from "react-spinners";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { useEffect, useState } from "react";
import { UnsavedChangesProvider } from "./components/common/UnsavedChanges";

/**
 * The app's router. A data router rather than `<BrowserRouter>` so edit pages can hold a
 * navigation that would lose unsaved changes (`useBlocker`, AKL-1083). Its one catch-all
 * route renders the app, whose own `<Routes>` still match every path as before.
 *
 * Created once per mount in state, not per render: a new router would drop the current
 * location's state and its history listener.
 * @returns the router
 */
const AppRouter = () => {
  const [router] = useState(() =>
    createBrowserRouter([
      {
        path: "*",
        element: (
          <ProfileProvider>
            <UnsavedChangesProvider>
              <App />
            </UnsavedChangesProvider>
          </ProfileProvider>
        ),
      },
    ]),
  );
  return <RouterProvider router={router} />;
};

const AuthGate = () => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized && !keycloak.authenticated) {
      keycloak.login();
    }
  }, [initialized, keycloak]);

  // While Keycloak is still initializing
  if (keycloak.authenticated === undefined) {
    return (
      <div className="w-full flex justify-center mt-8">
        <BeatLoader color={"#272837"} loading={true} size={15} margin={5} />
      </div>
    );
  }

  if (keycloak.authenticated) {
    return <AppRouter />;
  }

  return (
    <div className="w-full flex justify-center mt-8">
      <BeatLoader color={"#272837"} loading={true} size={15} margin={5} />
    </div>
  );
};

export default AuthGate;
